import * as date from './date';
import * as url from './url';


//手机号脱敏处理
function transformPhone <T>(value: T): T | string {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.replace(/(\d{3})\d*(\d{4})/,`$1****$2`);
}

const Filter = {
  ...date,
  ...url,
  transformPhone
}

export default Filter;
